import { Button, Card, CardContent, CardHeader, MenuItem, Popper, Stack, Switch, TextField, Typography,ClickAwayListener, CardActions } from "@mui/material"
import React, { useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { QuestionMark } from "@mui/icons-material";
import { editCaseManClinicalReview } from "../../../../../services/caseManService/model/caseMan/CaseManagementSlice";
import { ReduxUpdate } from "../../../../../utils/ReduxUpdateCommands";

function HistoryAndPhysicalEdit(){
    const dispatch = useAppDispatch();
    const caseManage = useAppSelector((state)=>state.caseManagement.caseManagement);
    const[popout, setPopout] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    
    return <React.Fragment>
        <Stack direction='row' alignSelf='center'>
        <TextField label='History and Physical' select defaultValue='Incomplete' sx={{width:'200px'}}
            value={caseManage.clinicalReview?.historyAndPhysical} onChange={(e)=>dispatch(editCaseManClinicalReview(new ReduxUpdate('historyAndPhysical',e.target.value)))}>
            <MenuItem value='Incomplete'>Incomplete</MenuItem>
            <MenuItem value='Pending'>Pending</MenuItem>
            <MenuItem value='Complete'>Complete</MenuItem>
            <MenuItem value='Not Required'>Not Required</MenuItem>
            <MenuItem value='Does Not Support'>Does Not Support</MenuItem>
        </TextField>
        <Button name='questions' startIcon={<QuestionMark/>} variant='text' onClick={(e)=>{setPopout(true);setAnchorEl(e.currentTarget)}}/>
        </Stack>
        <Popper open={popout} placement='right'  sx={{zIndex:100}} anchorEl={anchorEl}>
            <Card>
                <CardHeader title='History and Physical'/>
                <CardContent>
                <ul>
                <li>Current condition(s) related to need for procedure</li>
                <li>Underlying condition(s) affecting patient care</li>
                <li>Signs</li>
                <li>Symptoms</li>
                <li>Past medical history</li>
                <li>Past surgical history</li>
                <li>Family history</li>
                <li>Previous procedures/hospitalizations</li>
                <li>Name/Birthdate/Gender/Height/Weight/BMI</li>
                <li>Medications and Allergies</li>
                <li>Physical Assessment with Smoking/Drug/ETOH Assessment</li>
                <li>Discussed risks/benefits with patient/significant other</li>
                <li>Vital signs including pain level</li>
                <li>The "plan"</li>
                </ul>
                </CardContent>
                <CardActions sx={{justifyContent:'center'}}><Button onClick={()=>setPopout(false)}>Close</Button></CardActions>
            </Card>
        </Popper>
    </React.Fragment>
}

export {HistoryAndPhysicalEdit}